import { useFetchSubsidyCalculatorData } from './useFetchSubsidyCalculatorData';

interface Params {
  accountId: string;
}

export function useSubsidyCalculator({ accountId }: Params) {
  const { selectedProgramId, programOptions, isOptionsLoading, isProgramLoading, financeProgram, selectProgram } =
    useFetchSubsidyCalculatorData({ accountId });

  const isSubsidyEligible =
    !!financeProgram &&
    (!!financeProgram.paymentOptionsConfiguration?.isSubsidized ||
      (financeProgram.paymentOptionsConfiguration?.subsidyPercent ?? 0) > 0);

  const subsidyPercent = financeProgram?.paymentOptionsConfiguration?.subsidyPercent ?? 0;
  const dnetPercent = financeProgram?.paymentOptionsConfiguration?.dnetPercent ?? 0;

  return {
    selectedProgramId,
    programOptions,
    isOptionsLoading,
    isProgramLoading,
    program: financeProgram,
    isSubsidyEligible,
    subsidyPercent,
    dnetPercent,
    handleProgramChange: selectProgram,
  };
}
